module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasReports),
      expression: "hasReports"
    }],
    attrs: {
      "id": "listReports"
    }
  }, [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": "Reports",
      "subTitle": "A list of reported items"
    }
  }), _vm._v(" "), _c('mu-list', {
    attrs: {
      "id": "listReportsScroll"
    }
  }, [_vm._l((_vm.reports), function(report, index) {
    return _c('mu-list-item', {
      key: ("report-" + index),
      staticClass: "report",
      attrs: {
        "disableRipple": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goToReport(report)
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [(report.comment !== null) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(("Comment: " + (report.comment.substr(0, 100)))))
      }
    }) : _vm._e(), _vm._v(" "), (report.comment === null) ? _c('div', [_vm._v("Comment: No comment")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "info",
      attrs: {
        "slot": "default"
      },
      slot: "default"
    }, [_c('p', [_vm._v("Reported user: " + _vm._s(report.reported_user))]), _vm._v(" "), _c('p', [_vm._v("Reported by: " + _vm._s(report.reported_by))]), _vm._v(" "), _c('p', [_vm._v("Reason: " + _vm._s(report.reason))]), _vm._v(" "), _c('p', [_vm._v("Date: " + _vm._s(_vm.formatDate(report.date)))]), _vm._v(" "), _c('p', [_vm._v("Time(s) reported: " + _vm._s(report.amount))])]), _vm._v(" "), _c('mu-icon', {
      attrs: {
        "slot": "right",
        "value": "rate_review"
      },
      slot: "right"
    })], 1)
  }), _vm._v(" "), (_vm.isAppending && !_vm.isFinished) ? _c('mu-content-block', {
    staticClass: "loader"
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 40
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "scrollDetector"
    }
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f1935ee","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/ListReports.vue
// module id = 3166
// module chunks = 1